import script from "./StreamsManageSecuritySettings.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageSecuritySettings.vue?vue&type=script&setup=true&lang=js"

import "./StreamsManageSecuritySettings.vue?vue&type=style&index=0&id=4c5c5b31&lang=css"

const __exports__ = script;

export default __exports__